import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TaskaddPage } from './taskadd.page';

const routes: Routes = [
  {
    path: '',
    component: TaskaddPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TaskaddPageRoutingModule {}
